import { Component, OnInit, Inject} from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { constants } from 'src/app/shared/common/contants';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ReporttemplateService } from "src/app/shared/services/reporttemplate.service";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import {fakeAsync} from '@angular/core/testing';
import {CommonService} from '../../shared/services/common.service';
import {
  IncrementalDataLoadSchedulePopupComponent
} from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import * as moment from 'moment/moment';
import { SelectFiltersPopUpComponent } from '../report-configuration/select-filters-pop-up/select-filters-pop-up.component';
import { TemplateReportService } from 'src/app/shared/services/template-report.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { FilterViewButton } from 'src/app/shared/common/FilterViewButton';
import {ConditionalOPeratorTypeWhere} from 'src/app/user/report-configuration/select-filters-pop-up/select-filters-pop-up.component';
export interface FormData {
  reportTemplateId: any;
  reportName: any;
  screenName:any;
  datasetid:any;
  selectedFiltersArray:[];
}
@Component({
    selector: 'app-report-template-popup',
    templateUrl: './report-template-popup.component.html',
    styleUrls: ['./report-template-popup.component.scss'],
    standalone: false
})
export class ReportTemplatePopupComponent implements OnInit{
  rowData: any[] = [];
  templateCreationMasterId: any;
  reportName: any;
  templatecreationmaster: UntypedFormGroup;
  components: any;
  scheduletable: any = [];
  filterstable: any = [];
  validation_messages


  templateCreationData = {
    "templateCreationMstrId": "",
    "reportName": "",
    "createSchedulesMstrid": "",
    "filterManageId":[] as any,
    "isReportTemplateScreen":false,
   }
   drawerRowData=[{
    "label": "",
    "whereCondition": "",
    "whereValue": "",
   }];
  templateName: any;

  backgroundColorButton = "";

  gridApi;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  pageSize;

  rowClassRules;

  defaultColDef;

  columnDefs;

  drawerColumnDefs;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  agGridShow = false;

  reportInstancesObject: any;

  value;

  retrieveRequestDetails

  selectSchedule

  selectfilter=""

  isReportTemplateScreen=false;

  datasetid=null;

  getfilters: any = {};

  selectedFilterDetails: any;

  innergridApi;

  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
      { name: "Matches", value: "=" },
      { name: "Does Not Matches", value: "<>" },
      { name: "Matches At Least One", value: "IN" },
      { name: "Starts With", value: "Starts with" },
      { name: "Ends With", value: "Ends with" },
      { name: "Contains", value: "contains" },
      { name: "Greater Than Or Equals", value: ">=" },
      { name: "Is Greater Than", value: ">" },
      { name: "Less Than Or Equals", value: "<=" },
      { name: "Is Less Than", value: "<" },
      { name: "Between", value: "BETWEEN" },
      { name: "Space Separated", value: "Space Separated" },
      { name: "MAX", value: "MAX" },
      { name: "MIN", value: "MIN" },
      { name: "Calculated Field", value: "CalculatedField" },
      { name: "Calculated Field With Filter", value: "CalculatedFieldWithFilter" },
      { name: "Calculated Field For Reports", value: "CalculatedFieldForReports" }
    ];

  constructor(private dialogref: MatDialogRef<ReportTemplatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
              private msg: ErrorMessages,
              private validation: validationmethod,
              private spinner: NgxUiLoaderService,
              private fb: UntypedFormBuilder,
              private formFieldsTrimer: FormFieldsTrimer,
              private constants: constants,
              private service: ReporttemplateService,
              private localStorageSettings: LocalStorageSettingsService,
              private linkservice: ReportlinksserviceService,
              private commonService:CommonService,
              private serviceTemplate: TemplateReportService,
              private reportingService: ReportingServiceService,
              private snackbar: MatSnackBar,
              private dialog: MatDialog,
              private reportService: ReporttemplateService) {
    this.validation_messages = this.msg.templatecreationmessages;

    this.components = {
      buttonRenderer: FilterViewButton,
    };
  }

  formValidation() {
    this.templatecreationmaster = new UntypedFormGroup({
      templatename: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator, Validators.maxLength(100)]),
      reportname: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.restrictAllSpecialCharactersExceptHyphenAndUnderscore, Validators.maxLength(100)]),
      selectschedule: new UntypedFormControl('', [Validators.required]),
      selectdataSet: new UntypedFormControl('', [])
    });
  }

  async ngOnInit() {
    console.log(this.data)
    this.templateCreationData.templateCreationMstrId = this.data.reportTemplateId;
    
    if(this.data.screenName=='Report Template'){
      this.templateCreationData.isReportTemplateScreen = true
      this.isReportTemplateScreen=true;
    }

    console.log(this.templateCreationData.templateCreationMstrId);

    this.reportName = this.data.reportName;

    console.log(this.reportName);

    this.templateName = this.reportName;

    this.formValidation();

    this.scheduletable = await this.service.retrieveTrnxService("createSchedulesmstr");

    console.log(this.scheduletable);
    if(this.data.datasetid!=null){
      this.filterstable=await this.service.retrieveFiltermanagebyDataSetid(this.data.datasetid)
      console.log(this.filterstable)
    }else{

    this.filterstable = await this.service.retrieveTrnxService("filtermanage");
    }
    console.log(this.filterstable);


    if (this.isReportTemplateScreen){
      this.reportInstancesObject = await this.commonService.retrieveSingleRecordService('retrieveinstanceschedules_view','templatecreationmstrid',this.templateCreationData.templateCreationMstrId)
      console.log(this.reportInstancesObject);
    }else{
      this.reportInstancesObject = await this.service.retrieveTrnxService1();

    }



    this.agGridShow = true;

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    this.columnDefs = [
      {
        headerName: 'Report Name',
        headerTooltip: 'Report Name',
        tooltipValueGetter: (params) => 'Report Name : ' + params.value,
        field: 'reportname',
        filter: 'agTextColumnFilter',
        width: 160
      },
      {
        headerName: 'ScheduleId',
        headerTooltip: 'ScheduleId',
        tooltipValueGetter: (params) => 'Schedule Id : ' + params.value,
        field: 'createschedulesmstrid',
        filter: 'agTextColumnFilter',
        width: 160
      },
      {
        headerName: 'Schedule Name',
        headerTooltip: 'Schedule Name',
        tooltipValueGetter: (params) => 'Schedule Name : ' + params.value,
        field: 'schedulename',
        filter: 'agTextColumnFilter',
        width: 160
      },
      {
        headerName: 'Schedule Description',
        headerTooltip: 'Schedule Description',
        tooltipValueGetter: (params) => 'Schedule Description : ' + params.value,
        field: 'scheduledesc',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Filter Name',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: (params) => {
           console.log('params data:', params.data); // 👈 add this log
          return {
            openPanel: this.openPanel.bind(this),  // 👈 method reference
           // onOpenDrawer: this.showDrawerWithData.bind(this), // pass parent function
            rowData: params.data,                             // pass row data if needed
          };
          
        },
        width: 200,
      },
    ];
    
    //
    this.drawerColumnDefs = [
      {
        headerName: 'Label',
        headerTooltip: 'Label',
        tooltipValueGetter: (params) => 'Label : ' + params.value,
        field: 'label',
        filter: 'agTextColumnFilter',
        width: 160
      },
      {
        headerName: 'Condition',
        headerTooltip: 'Condition',
        tooltipValueGetter: (params) => 'Condition: ' + params.value,
        field: 'whereCondition',
        filter: 'agTextColumnFilter',
        width: 160
      },
      {
        headerName: 'Value',
        headerTooltip: 'Value',
        tooltipValueGetter: (params) => 'Value: ' + params.value,
        field: 'whereValue',
        filter: 'agTextColumnFilter',

        width:240

      },
    ];
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "rowBackgroundColor": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = "single";

    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

  }  
  cancel() {

    this.dialogref.close();

  }

  bindSelectSchedule(scheduleValue){

   this.templateCreationData.createSchedulesMstrid = scheduleValue;


  }

  bindSelectFilter(scheduleFilter){

    this.templateCreationData.filterManageId = scheduleFilter;
  }

  //excel export function
  onBtExport() {

    this.gridApi.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridApi) {

      this.lastPage = this.gridApi.paginationIsLastPageFound();

      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1

      this.nextPage = this.gridApi.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridApi.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridApi.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridApi.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    this.gridApi.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridApi.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridApi.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridApi.paginationGoToLastPage();

  }
  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params) {

    this.gridApi = params.api;

    this.gridApi.setGridOption('rowData', this.reportInstancesObject);
  }
  onSideGridReady(params) {
    const allColumnIds: string[] = [];
    params.columnApi.getAllColumns()?.forEach(column => {
      allColumnIds.push(column.getColId());
    });
    params.columnApi.autoSizeColumns(allColumnIds);
  }
  /// 
  onInnerGridReady(params){
    console.log('Inner grid is ready', params);
    this.innergridApi = params.api;
     // Populate grid if rowData already set
    this.innergridApi.setGridOption('rowData', []);
  
  }


  save() {
    if (!this.templatecreationmaster.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.templatecreationmaster);
      this.validation.getvalidationmessage();
    }else{
      /**
       * Modified By : Nitin Kumar
       * Added && condition to verify whether templateCreationData.filterManageId is an Array or not
       * 26/06/2024
       */
      if(this.templateCreationData.filterManageId!=null && Array.isArray(this.templateCreationData.filterManageId)){
      this.templateCreationData.filterManageId =this.templateCreationData.filterManageId.join(',');}
      console.log(this.templateCreationData);
      this.linkservice.insertReportInstance(this.templateCreationData).subscribe(response => {
        this.spinner.start();
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop();

        } else {
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop();
          this.dialogref.close();
        }

      });
    }
  }

  selectSchedulerClick() {

    let obj =  {
    customreportmstrid:this.templateCreationData.templateCreationMstrId
    }
    let dialogRef = this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: "80%",
      autoFocus: false,

      data: { edata: obj,scheduleFor:'Report Template'},

      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(obj => {
      console.log("obj: ",obj);
      this.templateCreationData.createSchedulesMstrid = obj.scheduleid
      this.selectSchedule = obj.scheduleDesc
    });
  }

/**
 * @author Abhishek Tomar
 * @date 2024-08-29
 * @description This function formats we are using for retriving the dataset for accociated with the reports
 */
  async  getDatasetDetails() {
   let  objectgroupid=0;
   let datasetDetails: any
    try {
      this.spinner.start()
      console.log(this.data)
      let response=null;
      if(this.data.datasetid!=0){
       response = await this.reportingService.retrieveDatasetDetails(parseInt(this.data.datasetid)).toPromise();
      }
      else{
        response = await this.reportingService.retrieveDatasetDetailsByBinder(parseInt(this.data.reportTemplateId)).toPromise();
        if (response) {
          // Use reportcreationid as datasetId for vault case
          this.data.datasetid = response.reportcreationid;
          datasetDetails = response;
        }
      }
      console.log(response);
      datasetDetails = response;
      console.log(datasetDetails);
       objectgroupid=datasetDetails.objectGroup
       this.selectFilterPopup(objectgroupid,datasetDetails);
      // Additional logic that depends on the datasetDetails can go here
    } catch (error) {
      this.spinner.stop()
      this.snackbar.open("Filters not found", "OK", {
        duration: 5000,
      });
      return;
    }
  }


  selectFilter(){
 
      this.getDatasetDetails();
  }
    // console.log(datasetDetails)

    /**
 * @author Abhishek Tomar
 * @date 2024-08-29
 * @description function to open the filter pop-up and updating the value of filter which user selecting
 * and making the filters compatible with the EMR and passing the filterid for report creation
 */
    selectFilterPopup(objectgroupid,datasetDetails){
      console.log(datasetDetails);
      
    let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
      width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "90%",
      disableClose: true,
       data: { dataSetId: this.data.datasetid, objectGroup : objectgroupid,columnsData:datasetDetails.columns,datasetData:datasetDetails,selectedFiltersArray:this.data.selectedFiltersArray}
    });
    let where=[]
    const distinctFilterManageIds = new Set<number>();
     dialogRef.afterClosed().subscribe(result => {
            console.log(result.selectedFiltersListString);
      this.selectfilter=""
      if(result.selectedFiltersListString){
       
      
            let getdata= JSON.parse(result.selectedFiltersListString)
            
            let filterMap = new Map<number, any[]>();
            
           
  
            // Group filters by filtermanageId
            getdata.forEach((filter: any) => {
              filter.filterType = "reportFilter"
              let filtermanageId = filter.manageFilterId;
              distinctFilterManageIds.add(filtermanageId);
              delete filter.manageFilterId
              if (!filterMap.has(filtermanageId)) {
                filterMap.set(filtermanageId, []);
              }
  
              switch (filter.whereConditionValue) {
                case "Ends with":
                  filter.whereCondition="LIKE";
                  filter.whereValue = `%${filter.whereValue}`;
                  break;
                  
                case "Starts with":
                  filter.whereCondition="LIKE";
                  filter.whereValue = `${filter.whereValue}%`;
                  break;
                case "contains":
                  filter.whereValue = `%${filter.whereValue}%`;
                  break;
                case "Contains (Exclude)":
                filter.whereValue = `%${filter.whereValue}%`;
                break;
                  case "BETWEEN":
                  filter.whereValue1 = `'${filter.whereValue1}'`.replace(/\//g, "-");
                  filter.whereValue = `${filter.whereValue}`.replace(/\//g, "-");
                 // if(filter.whereValue=="'Invalid date'"){filter.whereValue="''"}
                  break;
                  case "IN":
                    
                    filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                    
                    break;
                     case "NOT IN":
                  filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                  break;
                default:
                  break;
              }
              if(filter.type=="DateTime"&&filter.whereValue=="Invalid date"){
                // console.log(filter.whereValue=="'Invalid date'")
                filter.whereValue=''
              }
              if (filter.whereConditionValue!="IN"){
                filter.whereValue = `'${filter.whereValue}'`;
                }
              //filter.whereValue = `'${filter.whereValue}'`;
              //Ignoring the calculatedfield
              if (filter.whereConditionValue.toLowerCase() !== "calculatedfield".toLowerCase() && filter.whereConditionValue.toLowerCase() !== "CalculatedFieldWithFilter".toLowerCase()){
                filterMap.get(filtermanageId)?.push(filter);
                }
            });
            
            // Create an array of FilterManageDto objects
            let filterArray = [];
            this.selectfilter=""
            filterMap.forEach((filters, filtermanageId) => {
             let filtername= this.getFilterNameById(filtermanageId,this.filterstable)
             console.log(filtername);
             if(filtername!=null){
              if(this.selectfilter!=null && this.selectfilter!=""){
              this.selectfilter+=","+filtername}
              else{
                this.selectfilter=filtername
              }
             }
              let filterDto = {
                filtermanageId: filtermanageId,
                selectedFilters: filters, 
              };
       
              filterArray.push(filterDto);
            });
            
            console.log(filterArray);
            if(filterArray.length>0){
            this.serviceTemplate.updateFilters(filterArray).subscribe(response => {
              this.spinner.start();
              console.log(response);
             // checking if response is true or not
              // this.snackbar.open(response.statusMessage, "OK", {
              //   duration: 5000,
              // });
              this.spinner.stop();
              // this.dialogref.close();
    
            });}
         
            if(Array.from(distinctFilterManageIds).length>0){
              this.templateCreationData.filterManageId= Array.from(distinctFilterManageIds)
              
             }
            }
         
  
     }   );
  
        
  }
  formatForInString(input): string {
    console.log(input);
    console.log(typeof input)
    // Split the input string by commas
    // const items = input.split(',');
  
    // Trim whitespace and enclose each item in single quotes
    const formattedItems = input.map(item => `'${item.trim()}'`);
  
    // Join the formatted items with commas
    return formattedItems.join(', ');
  }
  getFilterNameById(filtermanageid: number, filters): string | null {
    for (let i = 0; i < filters.length; i++) {
        if (filters[i].filtermanageId === filtermanageid) {
            return filters[i].filtername;
        }
    }
    return null; 
}
showSidePanel = false;
selectedRowData: any;
async viewFilter(params){
  
  event.preventDefault(); // optional to prevent default link behavior
  console.log("Params:",params);
 const filterName=params.rowData.filtername;
 console.log("Passed filtername:",filterName);
 const separate:string[] = filterName.split(",").map(s => s.trim());
 const fId=params.rowData.filtermanageId;
 //console.log(params.rowData.filtermanageId);
 const sfIds = fId.split(",").map(s => parseInt(s.trim(), 10));
 console.log("Passed filtername:",params.filtername);
 let pos=0;
 for(let i=0;i<separate.length;i++){
if(params.filtername===separate[i]){
  pos=i;
}
 }
  // Call your API with the filterId
  const filterData = await this.reportService.retrieveFiltermanagebyFilterid(sfIds[pos]);
  console.log("Filter Data:",filterData);
  let filters = [];
  let filtersString=filterData[0].filters;
if (filtersString) {
  try {
    filters = JSON.parse(filtersString);
    console.log("parsed Filters:",filters);
  } catch (e) {
    console.error("Error parsing filters:", e);
  }
}
  // Store it in a variable bound to your side panel UI
  filters.forEach(filter => {
    const match = this.conditionalOperatorDataWhere.find(
      op => op.value === filter.whereCondition
    );
  
    if (match) {
      // Add the name to the filter object
      filter.whereCondition = match.name;
    }
  });
  
  this.selectedFilterDetails = filters;
  console.log("selectedFilterDetails:",this.selectedFilterDetails);
 // this.drawerRowData=this.selectedFilterDetails;
  this.showSidePanel = true;
  
  // if (this.innergridApi) {
  //   this.innergridApi.setGridOption('rowData', this.drawerRowData);
  // }
  return separate;
}


async openPanel(params) {
 let currentIds=await this.viewFilter(params);
 console.log(this.selectedFilterDetails);
 //this.showSidePanel = true;

}
closeSidePanel() {
  this.showSidePanel = false;
  //this.selectedRowData = null;
}
}
